// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".about .about-text-info>div{height:140px;font-size:14px;line-height:19px;font-family:\"HelveticaNeuyeCyr-Roman\",\"Helvetica\",sans-serif;padding:18.5px 8px 18.5px 14px;align-items:start}.about .about-text-info>div textarea{padding:0 10px 0 0}.about ::-webkit-scrollbar{width:3px}.about ::-webkit-scrollbar-thumb{background:#DFDFE6;border-radius:5px}.about ::-webkit-scrollbar-thumb:hover{background:none}\n", ""]);
// Exports
module.exports = exports;
